const UserSingleAddressPage = () => {
  return (
    <div className="user-new-address-page shared-dashboard-page shared-custom-page">
      <h1>single address page</h1>
    </div>
  );
};

export default UserSingleAddressPage;
